export const ImportFolderType = {
  Patient: 'patients',
  User: 'users',
  Assessment: 'assessments',
};
